/* eslint-disable */
import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true); setMsg(null);
    try {
      const r = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setMsg({ ok: true, text: r.data?.message || "If an account exists for that email, a reset link is on its way." });
    } catch {
      // Backend never leaks account existence; keep the same message.
      setMsg({ ok: true, text: "If an account exists for that email, a reset link is on its way." });
    } finally { setBusy(false); }
  }

  return (
    <div className="m-auth-page">
      <div className="m-auth-aside">
        <div className="m-auth-logo-wrap">
          <img src="/brand/metier-logo-gold.png" alt="Métier" />
        </div>
        <div>
          <span className="m-eyebrow">Métier · Membership</span>
          <h1 className="m-auth-heading">Reset your <em>access</em>.</h1>
          <p className="m-auth-lede">One-time link. Thirty-minute window. Back to work in a minute.</p>
        </div>
        <div className="m-auth-foot-aside"><span>workmetier.com</span></div>
      </div>
      <div className="m-auth-main">
        <div className="m-auth-card">
          <span className="m-eyebrow">Forgot password</span>
          <h2 className="m-auth-h2">Send a <em>reset link</em>.</h2>
          <p className="m-auth-lede">
            Enter the email on your Métier account. We&apos;ll send a one-time reset link that expires in 30 minutes.
          </p>

          <form onSubmit={onSubmit} className="m-form">
            <label className="m-field">
              <span>Email</span>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="email"
                data-testid="forgot-email"
              />
            </label>
            {msg && (
              <div className={"m-form-msg " + (msg.ok ? "ok" : "err")} data-testid="forgot-msg">
                {msg.text}
              </div>
            )}
            <button
              type="submit"
              className="m-btn-gold"
              disabled={busy}
              data-testid="forgot-submit"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>

          <p className="m-auth-foot">
            Remembered it? <Link to="/login" data-testid="link-back-login">Back to sign in →</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
